import Layout from "layout";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import orderCompleted from "@/assets/order-completed.png";
import { useCartDrawer } from "context/CartDrawerContext";
import {
  MainContainer,
  StyledButton,
  StyledHeading,
  StyledImage,
} from "./styles";

const OrderSuccessPage = () => {
  const navigate = useNavigate();
  const { clearCart } = useCartDrawer();

  useEffect(() => {
    clearCart();
  }, [clearCart]);

  const handleNavigate = () => {
    navigate("/best-selling-products");
  };
  return (
    <Layout>
      <MainContainer>
        <StyledImage src={orderCompleted} />
        <StyledHeading>{`Your Order has been placed`}</StyledHeading>
        <StyledButton
          onClick={handleNavigate}
        >{`Back to Product List`}</StyledButton>
      </MainContainer>
    </Layout>
  );
};

export default OrderSuccessPage;
